export const RECRUITMENT_SIZE_WITH_COINS_DEFAULT = 1;
export const RECRUITMENT_SIZE_WITH_COINS_WITH_ARSENAL = 2;
